<template>
  <div>
    <scholar-overview v-if="role == 'SCHOLAR'" />
    <vendor-overview v-if="role == 'VENDOR'" />
    <cue-overview v-if="role == 'TF'" />
    <admin-overview v-if="role == 'SUPERADMIN'" />
    <div class="pa-2"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import adminOverview from "./adminOverview.vue";
import CueOverview from "./cueOverview.vue";
import ScholarOverview from "./scholarOverview.vue";
import VendorOverview from "./vendorOverview.vue";
export default {
  components: { adminOverview, ScholarOverview, VendorOverview, CueOverview },
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
};
</script>

<style></style>
